module.exports = __webpack_public_path__ + "img/confidential-clients.5c24181c.png";